// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hy","advertCardPhoto__image":"c-a_hz"};